module.exports = __webpack_public_path__ + "static/media/pev.2d4b12ea.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/CasePeriod/imgs/pev.svg
// module id = 600
// module chunks = 0